<template>
    <div class="form-control select-multiple-control">
        <div class="list">
            <!-- <div class="text-muted selected-count" style="display:none">
                {{selectedCount}} seçili
            </div> -->
            <table class="table table-borderless table-sm" :class="{ 'table-striped table-hover': selectedCount }">
                <tbody>
                    <tr v-for="i in value" :key="i">
                        <td v-if="!readonly" class="remove" title="Kaldır" style="min-width:32px; max-width:32px;" @click="remove(i)"></td>
                        <td class="content">
                            <slot :item="findItem(i)" v-if="hasSlot()"></slot>
                            <template v-else>{{getText(findItem(i))}} {{getMail(findItem(i))}}</template>
                        </td>
                    </tr>
                    <tr v-for="i in additionalItems" :key="i.Id">
                        <td v-if="!readonly" class="remove" :title="translate('remove')" @click="$emit('removeAdditionalItem', i)"></td>
                        <td class="content">
                            <slot :item="i" v-if="hasSlot()"></slot>
                            <template v-else>{{getText(i)}}</template>
                        </td>
                    </tr> 
                    <tr v-if="selectedCount == 0 && (!additionalItems || additionalItems.length == 0)">
                        <td class="text-muted text-center" style="padding:20px 0">
                            <small style="font-style:italic;">{{emptyLabel}}</small>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <template v-if="!readonly">
            <select-input
                ref="selectInput"
                :value="selectedValue"
                :autocomplete="autocomplete"
                :placeholder="translate('search')"
                :items="availableItems"
                :isInSelectMultiple="true"
                :filter-function="(item, search) => new RegExp(search, 'i').test(getText(item))"
                @change="change"
                >
                    <span class="text-muted">{{chooseLabel}}</span>
                    <template v-slot:item="{item}">
                        <div style="padding:2px 0;">
                            {{getText(item)}}
                        </div>
                    </template>
            </select-input>
        </template>

    </div>
</template>

<script>
import selectInput from './SelectInput.vue'
import i18n from '../i18n';
export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    components: {
        selectInput
    },
    data(){
        return {
            selectedValue: null,
            findItem: id => this.list?.filter(item => this.getValue(item) == id)[0]
        };
    },
    computed:{
        selectedCount(){
            return (this.value?.length ?? 0);
        },
        availableItems(){
            if(!this.value || !this.value.length)
                return this.list ?? [];

            return this.list?.filter(i => this.value.indexOf(this.getValue(i)) < 0) ?? [];
        }
    },
    props:{
        list: {
            type: Array,
        },
        value: {
            type:Array,
        },
        chooseLabel: {
            type: String,
            default: i18n.t('chooseLabel')
        },
        emptyLabel: {
            type:String,
            default: i18n.t('emptyLabel')
        },
        getText: {
            type: Function,
            default: item => item?.Name ?? item?.filterName ?? item?.name ?? this.translate('undefined')
        },
        getMail: {
            type: Function,
            default: item => item?.ExtraFields?.[0].Value  ? "("+ item?.ExtraFields?.[0].Value + ")" : ""
        },
        getValue: {
            type: Function,
            default: item => item?.Id
        },
        required: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default:false
        },
        autocomplete: {
            type: Boolean,
            default: false
        },
        additionalItems: {
            type: Array,
            default: null
        }
    },
    methods: {
        change(val) {
            if(!val)
                return;

            if(!this.value)
                this.value = [];

            this.value.push(val.Id);
            this.$emit('change', this.value);
            this.$refs.selectInput.focus();
        },
        remove(i) {
            //this.value = this.value.filter(x => x != i);
            
            var index = this.value.indexOf(i);
            if (index > -1) {
                this.value.splice(index, 1);
            }

            this.$emit('change', this.value);
        },
        hasSlot (name = 'default') {
            return !!this.$slots[name] || !!this.$scopedSlots[name];
        },
        print(i){
            console.log(i)
            return ""
        }
    }
}
</script>

<style scoped>
    .list {
        height: calc(100% - 38px);
        overflow-y:auto;
        min-height: 100px;
    }

    .select-multiple-control {
        padding: 0;
        height: auto;
        /* overflow: hidden; */
    }



    select {
        border:0;
        width:100%;
        padding: 4px;
        border-top:1px solid #ced4da;
        outline: none;
    }

    .selected-count {
        position:relative;
        text-align: right;
        height: 0px;
    }
</style>